import { tw } from '@/utils/tw';
import BaseMorePagesTitleTheme from 'base/components/MorePagesTitle/theme';

const MorePagesTitle = tw.theme({
  extend: BaseMorePagesTitleTheme,
  base: `my-3 grid grid-cols-[min-content_auto_min-content] items-center gap-x-3 whitespace-nowrap px-4 text-headline-sm before:relative before:-top-1 before:col-start-3 before:row-start-1 before:block before:h-8 before:w-21 before:bg-[url(/image/allas-logo-logga-700.svg)] before:bg-no-repeat after:relative after:top-0.5 after:block after:h-px after:w-full after:bg-black`,
});

export default MorePagesTitle;
